import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLoaderData } from "react-router";

import { sanitize } from "dompurify";

import { store } from "../..";
import "../../assets/css/majorybl/pages/home.scss";
import logo from "../../assets/images/mybl_logo-lg.png";
import { alertActions } from "../../features/alert/alertSlice";
import {
    globalActions,
    selectSetting,
} from "../../features/global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { printRules } from "../../lib/api";
import { PrintIcon } from "../../lib/icons";

export const loader = async ({ content }: any) => {
    const settings = store.getState().global.settings;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    await Promise.all(promises);

    return {
        content,
    };
};

const Rules = (): React.JSX.Element => {
    const { content: rulesContent } = useLoaderData() as {
        content: string;
    };

    const pageContent = useAppSelector(state =>
        selectSetting(state, rulesContent),
    )?.setting;

    const dispatch = useAppDispatch();

    const handlePrint = async () => {
        dispatch(
            alertActions.warning({
                title: "Generating print file",
                text: "Please wait...",
            }),
        );

        await printRules(rulesContent)
            .then(async response => {
                window.open(response.file, "_blank");
            })
            .catch(e => {
                dispatch(
                    alertActions.error({
                        title: "There was a problem retreving the print file",
                        text: "If the problem persists, please contact a site admin.",
                        dismissible: true,
                    }),
                );
            })
            .finally(() => {
                dispatch(alertActions.clear());
            });
    };

    return (
        <div data-testid="rulesContent" className="rulesContent">
            <Container className="py-5">
                <Row>
                    <Col>
                        <div className="d-flex">
                            <img
                                src={logo}
                                alt="MAJORYBL Rules"
                                className="img-fluid"
                            />
                            <PrintIcon
                                className="printerIcon d-none d-lg-inline-block"
                                size="2x"
                                title="Print rules"
                                onClick={handlePrint}
                            />
                        </div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: sanitize(pageContent),
                            }}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Rules;
